import React from 'react';
import Theme from '../../theme';
import { StyleSheet, View, ActivityIndicator } from 'react-native';

const SocialAuthLoader = () => (
  <View style={styles.container}>
    <ActivityIndicator
      animating
      size="small"
      color={Theme.PRIMARY}
    />
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: Theme.WHITE,
  },
});

export default SocialAuthLoader;
